var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewChartOnboarding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6665 0.5C6.52437 0.5 3.1665 3.85786 3.1665 8H0.666504L3.90817 11.2417L3.9665 11.3583L7.33317 8H4.83317C4.83317 4.775 7.4415 2.16667 10.6665 2.16667C13.8915 2.16667 16.4998 4.775 16.4998 8C16.4998 11.225 13.8915 13.8333 10.6665 13.8333C9.05817 13.8333 7.59984 13.175 6.54984 12.1167L5.3665 13.3C6.76928 14.7105 8.67721 15.5025 10.6665 15.5C14.8086 15.5 18.1665 12.1421 18.1665 8C18.1665 3.85786 14.8086 0.5 10.6665 0.5ZM9.83317 4.66667V8.83333L13.3998 10.95L13.9998 9.94167L11.0832 8.20833V4.66667H9.83317Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewChartOnboarding);
export default __webpack_public_path__ + "static/media/viewChartOnboarding.87147e62.svg";
export { ForwardRef as ReactComponent };